import { Host, h } from '@stencil/core';
export class AibaUserAccordian {
  constructor() {
    this.componentWillLoad = async () => {
      if (this.handlers && this.handlers.handleUserAccordianLoad) {
        let stateData = await this.handlers.handleUserAccordianLoad();
        if (stateData) {
          if (stateData === null || stateData === void 0 ? void 0 : stateData.isLogin) {
            this.isLogin = stateData === null || stateData === void 0 ? void 0 : stateData.isLogin;
          }
          if (stateData === null || stateData === void 0 ? void 0 : stateData.user) {
            this.user = stateData === null || stateData === void 0 ? void 0 : stateData.user;
          }
        }
      }
    };
    this.data = undefined;
    this.handlers = undefined;
    this.toggle = false;
    this.isLogin = false;
    this.user = '';
  }
  toggleAccordian(e) {
    this.toggle = !this.toggle;
    this.handlers && this.handlers.toggleUserAccodian(e);
  }
  async handleLinkClick(e, eventName) {
    if (eventName) {
      this.handlers && this.handlers[eventName](e);
    }
  }
  render() {
    return (h(Host, null, h("div", { class: `accordian-wrapper ${this.toggle === false ? 'hide' : ''}` }, this.data.elements.map((element) => {
      if (element.name === 'user-accordian-header')
        return (h("div", { class: "accordian-header-wrapper" }, element.data.elements.map((item) => {
          if (item.name === 'left-panel') {
            return (h("div", { class: "user-icon" }, item.data.elements.map((element) => {
              if (element.name === 'aiba-icon') {
                return h("aiba-icon", Object.assign({}, element['data']));
              }
              if (element.name === 'aiba-label') {
                if (this.user && element['data']['_id'] === 'username') {
                  return h("aiba-label", Object.assign({}, element['data'], { text: this.user }));
                }
                else {
                  return h("aiba-label", Object.assign({}, element['data']));
                }
              }
            })));
          }
          if (item.name === 'right-panel') {
            return (h("div", { class: "button-wrapper" }, item.data.elements.map((element) => {
              var _a, _b, _c;
              if (element.name === 'aiba-button' && ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.iconOnly) === true) {
                return this.isLogin && h("aiba-button", Object.assign({}, element['data'], { handleClick: e => this.toggleAccordian(e) }));
              }
              if (element.name === 'aiba-button') {
                return this.isLogin
                  ? element['data']['_id'] && element['data']['_id'] === 'startSkinAnalysisButton' && (h("aiba-button", Object.assign({}, element['data'], { handleClick: this.handlers && ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.startSkinAnalysisClickHandler) })))
                  : element['data']['_id'] && element['data']['_id'] === 'seeFullExperience' && (h("aiba-button", Object.assign({}, element['data'], { handleClick: this.handlers && ((_c = this.handlers) === null || _c === void 0 ? void 0 : _c.seeFullExperienceClickHandler) })));
              }
            })));
          }
        })));
      if (element.name === 'user-accordian-body')
        return (this.isLogin && (h("div", { class: `user-accordian-body ${this.toggle === false ? 'hide' : ''}` }, element.data.elements.map((item) => {
          if (item.name === 'aiba-link')
            return h("aiba-link", Object.assign({}, item['data'], { clickEvent: (e) => this.handleLinkClick(e, item['data']['linkClickEvent']) }));
        }))));
    }))));
  }
  static get is() { return "aiba-user-accordian"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-user-accordian.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-user-accordian.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "toggle": {},
      "isLogin": {},
      "user": {}
    };
  }
}
//# sourceMappingURL=aiba-user-accordian.js.map
